<template>
    <div class="text-center text-xl align-middle max-w-main bg-vmain">
        <div class="flex pl-1 pr-1 pt-3 pb-3 justify-around  align-middle bg-footer bg-cover bg-center text-center w-full border-t-2 border-white" style="font-size: 12px;">
            <div @click="showIntroduce" class="flex-initial   max-h-8 inline-block cursor-pointer" >
                <img alt="company image" class="max-h-6 inline-block" src="@/assets/default_main/company.svg" >
                <h4 class="ml-1 inline-block font-semibold text-sm color-bold-vmain">Giới thiệu</h4>
            </div>
            <div @click="showQuestion" class="flex-initial  inline-block  max-h-8 cursor-pointer" >
                <img alt="question image" class="max-h-6 inline-block" src="@/assets/default_main/question.svg" >
                <h4 class="ml-1 inline-block font-semibold text-sm color-bold-vmain">Hỏi đáp</h4>
            </div>
            <div class=" flex-initial  inline-block space-x-2 max-h-8 ma cursor-pointer">
                <a href="https://vclick.vn/blog/">
                    <img alt="blog image" class="max-h-6 inline-block" src="@/assets/default_main/img_blog.svg" >
                    <h4 class="ml-1 inline-block font-semibold text-sm color-bold-vmain">Blog</h4>
                </a>
            </div>
            <div  class="flex-initial  inline-block space-x-2 max-h-8 cursor-pointer">
                <a href="tel:02437554190">
                    <img alt="support image" class="max-h-6 inline-block" src="@/assets/default_main/support.svg" >
                    <h4 class="ml-1 inline-block font-semibold text-sm color-bold-vmain">Hỗ trợ</h4>
                </a>
            </div>
        </div>

        <b-modal id="bv-modal-introduce" centered hide-header hide-footer>
            <div class="d-block text-center">
                <div class="mt-2 font-bold color-bold-vmain">
                    Giới thiệu Vclick
                    <!-- <div class="grid grid-cols-8 gap-4">
                        <div class="col-span-7 color-main" style="font-size: 18px;">
                            Giới thiệu Vclick
                        </div>
                        <div >
                            <b-icon @click="$bvModal.hide('bv-modal-introduce')"  scale="1" icon="x-lg" variant="secondary" ></b-icon>
                        </div>
                    </div> -->
                </div>
                <div class="mt-2 p-2 text-justify">
                    <div>
                        Vclick là Sàn tín dụng kết nối người cần vay với các ngân hàng và tổ chức tín dụng uy tín. 
                    </div>
                    <div class="mt-2">
                        Thông qua công nghệ đánh giá hiện đại, khách hàng sẽ tiếp cận khoản vay đơn giản và nhanh chóng hơn so với thông thường.
                    </div>
                    <div class="mt-2">
                        Vclick là sản phẩm của Công Ty Cổ Phần Đầu Tư Vega Fintech - đơn vị tiên phong áp dụng công nghệ AI, Big data nhằm tạo ra những sản phẩm, ứng dụng hàng đầu trong lĩnh vực tài chính, ngân hàng và bảo hiểm.
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal id="bv-modal-question" centered hide-header hide-footer>
            <div class="d-block text-center">
                <div class="mt-2 font-bold text-left">
                    <div class="grid grid-cols-8 gap-4">
                        <div class="col-span-8 text-center color-bold-vmain" style="font-size: 18px;">
                            Hỏi đáp
                        </div>
                    </div>
                </div>
                <div class="mt-2 p-2 text-justify">
                    <!-- <div class="border-main w-full rounded-lg">
                        <div class="relative rounded-md shadow-sm">
                        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                            <span class="color-main2 sm:text-sm"><b-icon icon="search"></b-icon></span>
                        </div>
                        <input type="text" @change="searchQuestion" v-model="search" name="price" id="price" class="block color-main2 w-full rounded-md pl-9 pr-4" placeholder="Tìm câu hỏi" />
                        </div>
                        
                    </div> -->

                    <div style=" white-space: nowrap;overflow-x: auto; border-bottom: 1px solid grey;" class="p-2 text-lg text-red-400">
                        <!-- <span>Thông tin về Vclick và Công ty</span> -->
                        <span v-for="item in list_type" :key="item.id" @click="fectQues(item.id)" class="mr-5 p-2 cursor-pointer" :class="{ typeActive : type == item.id ? true : false }"> {{item.name}} </span>
                        <!-- <span class="ml-5">Hồ sơ, cách thức giải ngân</span> -->
                    </div>
             
                    <div class="mt-4 border-2 border-gray-200 rounded-lg accordion grid grid-cols-1 divide-y divide-grey-color h-80" role="tablist" style="overflow-y: scroll;">
                        <div v-for="(item,index) in dataQuestion" :key="index" >
                            <div class="font-bold color-bold-vmain grid grid-cols-8 gap-4 p-2" role="tab" v-b-toggle="index +'_key'">
                                <div class="col-span-7">
                                    {{ item.name }}
                                </div>
                                <div class="active_collsape">
                                    <b-icon  scale="1" icon="chevron-down" variant="main-color" ></b-icon>
                                </div>
                                <div class="not_active_collsape">
                                    <b-icon  scale="1" icon="chevron-up" variant="main-color" ></b-icon>
                                </div>
                            </div>
                            <b-collapse class="p-2" :id="index+'_key'" visible accordion="my-accordion" role="tabpanel">
                                {{ item.content }}
                            </b-collapse>
                        </div>
                        
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import {getFaq} from '@/api/otp'
import router from "@/router";

export default {
    data() {
        return {
            search: '',
            type: 1,
            dataAll: [],
            dataQuestion: [],
            list_type: [
                {
                    id: 1,
                    name: 'Thông tin về Vclick và Công ty'
                },
                {
                    id: 2,
                    name: 'Thủ tục, Cách thức đăng ký vay'
                },
                {
                    id: 3,
                    name: 'Hồ sơ, cách thức giải ngân'
                }
            ],
            baseUrl: window.location.origin + router.options.base,
        }
    },
    methods: {
        fectQues(id){
            this.type = id
            this.fetchQuestion()
        },
        showIntroduce() {
            this.$bvModal.show('bv-modal-introduce')	
        },
        showQuestion() {
            this.$bvModal.show('bv-modal-question')
        },
        fetchQuestion() {
            getFaq({search: '',type: this.type}).then(res => {
                //console.log(res)
                this.dataAll = res.data
                this.dataQuestion = res.data
            })
        },
        searchQuestion(){
            //console.log(this.dataAll.filter(e => e.content.includes(this.search)))
            this.dataQuestion = this.dataAll.filter(e => e.content.toLowerCase().includes(this.search.toLowerCase()) || e.name.toLowerCase().includes(this.search.toLowerCase()))
        },
        viewBlog() {
            this.$router.push('/blog')
        }
    },
    created() {
        //this.baseUrl = window.location.origin + router.options.base
        //console.log(router)
        this.fetchQuestion()
    },
}
</script>
<style scoped>
.typeActive {
    border-bottom: 2px solid #f1674a;
    color: #f1674a;
    font-weight: 600;

}

.not-collapsed{
    color: #f1674a;
} 
.not-collapsed .active_collsape{
    display: none;
}

.collapsed .active_collsape{
    display: block;
}

.not-collapsed .not_active_collsape{
    display: block;
}

.collapsed .not_active_collsape{
    display: none;
}
</style>